import { useCustomMutate, useCustomQuery } from '../../../../../hooks/query';
import {
  getAuditAccountTypeList,
  getAuditActionList,
  getAuditRoleList,
  postAuditUploadData,
  postTransactionLog,
} from '../api-services/api';
import { AuditDownloadResponse } from '../models';
import {
  CANDIDATE_KEY_GET_AUDIT_ACCOUNT_TYPE_LIST,
  CANDIDATE_KEY_GET_AUDIT_ACTION_LIST,
  CANDIDATE_KEY_GET_AUDIT_ROLE_LIST,
  CANDIDATE_KEY_POST_ADMIN_AUDIT,
  CANDIDATE_KEY_POST_AUDIT_DOWNLOAD_LINK,
} from './keys';

export const useAuditAccountTypeListQuery = () =>
  useCustomQuery<string[]>(CANDIDATE_KEY_GET_AUDIT_ACCOUNT_TYPE_LIST, () =>
    getAuditAccountTypeList().then((res) => res.data)
  );

export const useAuditRoleListQuery = () =>
  useCustomQuery<string[]>(CANDIDATE_KEY_GET_AUDIT_ROLE_LIST, () =>
    getAuditRoleList().then((res) => res.data)
  );

export const useAuditActionListQuery = () =>
  useCustomQuery<string[]>(
    CANDIDATE_KEY_GET_AUDIT_ACTION_LIST,
    () => getAuditActionList().then((res) => res.data),
    {},
    true,
    false
  );

export const useAuditSearchList = (onSuccess: (res: any) => void, onError: (res: any) => void) =>
  useCustomMutate(CANDIDATE_KEY_POST_ADMIN_AUDIT, postTransactionLog, {
    onSuccess: (res) => onSuccess(res),
    onError: (err) => onError(err),
  });

export const useAuditDownload = (
  successCallback: (res: AuditDownloadResponse) => void,
  failCallback: (res: any) => void
) =>
  useCustomMutate(
    CANDIDATE_KEY_POST_AUDIT_DOWNLOAD_LINK,
    postAuditUploadData,
    {
      onSuccess: (res) => successCallback(res.data),
      onError: (err) => failCallback(err),
    },
    false,
    false
  );
